import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import CollapseCard from '../CollapseCard/CollapseCard';
import BOTManagementForm from './BOTManagementForm';
import BOTManagementLists from './BOTManagementLists';

class BOTManagementContainer extends Component {
    constructor(props) {
        super(props);

        this.path = String(this.props.location.pathname).split('/');

        this.blankRequestTicket = {
            employeeId: this.props.singleEmployee ? parseInt(this.props.userEmployee.employeeId) : 0,
            teamId: this.props.singleEmployee ? parseInt(this.props.userEmployee.teamMembership) : 0,
            clientId: 0,
            requestId: 0,
            requestOther: '',
            connectivityId: 0,
            connectivityOther: '',
            priorityId: 0,
            timeSavedEstimate: 0,
            clientDirected: false,
            notes: '',
            // timestamp: String(new Date().toISOString()).substring(0, 10),
            statusId: 0,
            assignedEmployeeId: 0,
            priorityRankId: 0,
            timeEstimate: 0,
            completed: '',
            updateNotes: '',
            projectType: 0,
            technologyStatus: 0,
            version: '',
            applicationName: '',
            applicationType: 0,
            technologyNotes: '',
            clientsUsing: []
        }
        this.state = {
            botRequestTickets: [],
            botRefs: [],
            botRequestTicketId: 0,
            editRequestTicket: { ...this.blankRequestTicket },
            newRequestTicket: { ...this.blankRequestTicket },
            employees: [],
            teams: [],
            requests: [
                { key: 1, value: 'Rules Manager' },
                { key: 2, value: 'Script' },
                { key: 5, value: 'Morning Script' },
                { key: 3, value: 'Custom Report' },
                { key: 4, value: 'Other (User Defined)' }
            ],
            priorities: [
                { key: 1, value: 'Low' },
                { key: 2, value: 'Medium' },
                { key: 3, value: 'High' }
            ],
            statuses: [
                { key: 1, value: 'No Status' },
                { key: 2, value: 'Assigned' },
                { key: 3, value: 'Testing' },
                { key: 4, value: 'Completed' },
                { key: 5, value: 'Rejected' }
            ],
            priorityRanks: [
                { key: 1, value: 'Low' },
                { key: 2, value: 'Medium' },
                { key: 3, value: 'High' }
            ],
            projectTypes: [
                { key: 1, value: 'Customer' },
                { key: 2, value: 'Internal' }
            ],
            technologyStatuses: [
                { key: 1, value: 'Active' },
                { key: 2, value: 'Inactive' },
                { key: 3, value: 'Rejected' }
            ],
            applicationTypes: [
                { key: 1, value: 'Script' },
                { key: 2, value: 'Executable' },
                { key: 3, value: 'Process' },
                { key: 4, value: 'Reports' },
                { key: 5, value: 'Rules Manager' }
            ],
            isLoaded: false,
            selectedSortColumnIndex: -1,
            selectedSortAscending: true,
        };
        this.columns = [
            { name: 'Requestor', sort: 'alpha', key: 'lastName', singleEmployeeHide: true },
            { name: 'Assigned', sort: 'alpha', key: 'assignedLastName' },
            { name: 'Team', sort: 'alpha', key: 'teamName', singleEmployeeHide: true },
            { name: 'Client', sort: 'alpha', key: 'clientName' },
            { name: 'Request Category', sort: 'alpha', key: 'requestCategory' },
            { name: 'Requestor Priority', sort: 'numeric', key: 'priorityId' },
            { name: 'Time Saved', sort: 'numeric', key: 'timeSavedEstimate' },
            { name: 'Est. Time to Complete', sort: 'numeric', key: 'timeEstimate' },
            { name: 'Priority Rank', sort: 'numeric', key: 'priorityRankId', desc: true, defaultSort: true },
            { name: 'Application', sort: 'string', key: 'applicationName' }
        ]
    }


    handleSort = (colIndex, setAscending) => {
        this.props.log('BOTManagementContainer.js/handleSort (colIndex)', colIndex);
        if (!this.columns[colIndex].sort || this.props.singleEmployee) return;
        this.setState((prevState) => {
            const ascending = setAscending != null ? setAscending : (colIndex === prevState.selectedSortColumnIndex) ? !prevState.selectedSortAscending : true;
            const botRequestTickets = [...prevState.botRequestTickets].sort((a, b) => {
                const a2 = (this.columns[colIndex].key != null && a[this.columns[colIndex].key] != null) ? a[this.columns[colIndex].key] : '';
                const b2 = (this.columns[colIndex].key != null && b[this.columns[colIndex].key] != null) ? b[this.columns[colIndex].key] : '';
                switch (this.columns[colIndex].sort) {
                    case "numeric":
                        return ascending ? a[this.columns[colIndex].key] - b[this.columns[colIndex].key]
                            : b[this.columns[colIndex].key] - a[this.columns[colIndex].key];
                    default:
                        return ascending ? a2.localeCompare(b2) : b2.localeCompare(a2)
                }
            });
            return {
                selectedSortColumnIndex: colIndex,
                selectedSortAscending: ascending,
                botRequestTickets: botRequestTickets,
            }
        }, () => {
            if (colIndex === 8) this.reorder(this.state.botRequestTickets, false, null);
        })
    }

    componentDidMount = () => {
        this.props.log('BOTManagementContainer.js/componentDidMount');
        this.getRequestTickets();
        this.getEmployees();
        this.getTeams();
    }

    getEmployees = () => {
        this.props.log('BOTManagementContainer.js/getEmployees');
        fetch('/api/employees/', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            }
        })
            .then(results => results.json())
            .then(results => {
                if (this.isUnmounted) return;
                if (results.success) {
                    this.setState({
                        employees: results.data
                            .filter(employee => employee.active)
                            .map(employee => {
                                return ({
                                    employeeId: employee.employeeId,
                                    firstName: employee.firstName,
                                    lastName: employee.lastName
                                })
                            })
                            .sort((a, b) => a.lastName.localeCompare(b.lastName))
                    });
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    getTeams = () => {
        this.props.log('BOTManagementContainer.js/getTeams');
        fetch('/api/teams/', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.setState({
                        teams: results.data
                    });
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    getRequestTickets = () => {
        this.props.log('BOTManagementContainer.js/getRequestTickets');
        const url = this.props.singleEmployee ? '/api/bot-management-home/' + this.props.userEmployee.employeeId : '/api/bot-management/';
        fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    const botRequestTickets = results.data.map(item => {
                        return { ...item, requestCategory: this.state.requests.filter(request => request.key === item.requestId)[0].value }
                    });
                    this.setState({
                        botRequestTickets: botRequestTickets,
                        botRefs: botRequestTickets.map(bot => { return { id: bot.id, ref: React.createRef() } })
                    }, () => {
                        const sortIndex = this.columns.findIndex(column => column.defaultSort);
                        if (sortIndex > -1) {
                            const desc = this.columns[sortIndex].desc != null ? this.columns[sortIndex].desc : false;
                            this.handleSort(sortIndex, !desc)
                        }
                        if (this.path != null && this.path[2] != null && parseInt(this.path[2]) > 0) {
                            this.onEditRequestTicket(parseInt(this.path[2]),true);
                            this.path = null;
                        }
                    });
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    onEditRequestTicket = (botRequestTicketId, scroll) => {
        this.props.log('BOTManagementContainer.js/onEditRequestTicket (botRequestTicketId)', botRequestTicketId);
        const botRequestTicket = [...this.state.botRequestTickets].filter(item => item.id === botRequestTicketId)[0];
        if (botRequestTicket == null) return;
        this.setState(() => {
            return {
                botRequestTicketId: botRequestTicketId,
                editRequestTicket: {
                    employeeId: botRequestTicket.employeeId,
                    teamId: botRequestTicket.teamId,
                    clientId: botRequestTicket.clientId,
                    requestId: botRequestTicket.requestId,
                    requestOther: botRequestTicket.requestOther,
                    connectivityId: botRequestTicket.connectivityId,
                    connectivityOther: botRequestTicket.connectivityOther,
                    priorityId: botRequestTicket.priorityId,
                    timeSavedEstimate: botRequestTicket.timeSavedEstimate,
                    clientDirected: botRequestTicket.clientDirected,
                    notes: botRequestTicket.notes,
                    statusId: botRequestTicket.statusId,
                    assignedEmployeeId: botRequestTicket.assignedEmployeeId,
                    priorityRankId: botRequestTicket.priorityRankId,
                    timeEstimate: botRequestTicket.timeEstimate,
                    completed: botRequestTicket.completed,
                    updateNotes: botRequestTicket.updateNotes,
                    projectType: botRequestTicket.projectType,
                    technologyStatus: botRequestTicket.technologyStatus,
                    version: botRequestTicket.version,
                    applicationName: botRequestTicket.applicationName,
                    applicationType: botRequestTicket.applicationType,
                    technologyNotes: botRequestTicket.technologyNotes,
                    timestamp: botRequestTicket.timestamp,
                    clientsUsing: botRequestTicket.clientsUsing != null ? JSON.parse(botRequestTicket.clientsUsing) : []
                }
            }
        }, () => {
            if (scroll) {
                setTimeout(() => {
                    // console.log(this.state.botRefs.filter(ref => ref.id === botRequestTicketId)[0].ref.current, botRequestTicketId);
                    this.state.botRefs.filter(ref => ref.id === botRequestTicketId)[0].ref.current.scrollIntoView();
                },200);
            }
        })
    }

    onDeleteRequestTicket = (botRequestTicketId) => {
        this.props.log('BOTManagementContainer.js/onDeleteRequestTicket (botRequestTicketId)', botRequestTicketId);
        fetch('/api/bot-management/' + botRequestTicketId, {
            method: 'DELETE',
            body: JSON.stringify({
                user: this.props.user
            }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.getRequestTickets();
                    this.props.addToast('Request ticket deleted successfully.', 5, 'success')
                } else {
                    this.props.addToast('Unable to delete request ticket.', 5, 'danger')
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    onChangeRequestTicket = (e, type) => {
        this.props.log('BOTManagementContainer.js/onChangeRequestTicket (e, type)', type, e.target.name, e.target.value, e.target.checked);
        e.persist();
        let thisRequestTicket = (type === 'edit') ? this.state.editRequestTicket : this.state.newRequestTicket;
        switch (e.target.name) {
            case "employees":
                const employeeId = parseInt(String(e.target.id).split('_')[1]);
                const index = thisRequestTicket.employees.findIndex(item => item === employeeId);
                if (index > -1) thisRequestTicket.employees.splice(index, 1);
                if (e.target.checked) thisRequestTicket.employees.push(employeeId);
                break;
            case "clientDirected":
            case "clientDirected-edit":
                thisRequestTicket.clientDirected = e.target.value === "true" ? true : false;
                break;
            case "botClients":
                const id2 = parseInt(String(e.target.id).split('_')[1]);
                const index2 = thisRequestTicket.clientsUsing.findIndex(item => item.id === id2);
                if (index2 > -1) thisRequestTicket.clientsUsing.splice(index2, 1);
                if (e.target.checked) thisRequestTicket.clientsUsing.push({ id: id2 });
                break;
            default:
                thisRequestTicket[e.target.name] = e.target.value;
        }
        this.setState(() => {
            return (type === 'edit') ? { editRequestTicket: thisRequestTicket } : { newRequestTicket: thisRequestTicket };
        });
    }

    handleCancelRequestTicket = () => {
        this.props.log('BOTManagementContainer.js/handleCancelRequestTicket');
        this.setState({
            editRequestTicket: { ...this.blankRequestTicket },
            botRequestTicketId: 0
        })
    }

    handleAddRequestTicket = (e) => {
        this.props.log('BOTManagementContainer.js/handleAddRequestTicket');
        fetch('/api/bot-management/', {
            method: 'POST',
            body: JSON.stringify({
                date: this.state.newRequestTicket.date,
                employeeId: this.state.newRequestTicket.employeeId,
                teamId: this.state.newRequestTicket.teamId,
                clientId: this.state.newRequestTicket.clientId,
                requestId: this.state.newRequestTicket.requestId,
                requestOther: this.state.newRequestTicket.requestOther,
                connectivityId: this.state.newRequestTicket.connectivityId,
                connectivityOther: this.state.newRequestTicket.connectivityOther,
                priorityId: this.state.newRequestTicket.priorityId,
                timeSavedEstimate: this.state.newRequestTicket.timeSavedEstimate,
                clientDirected: this.state.newRequestTicket.clientDirected,
                notes: this.state.newRequestTicket.notes,
            }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.setState({
                        newRequestTicket: { ...this.blankRequestTicket },
                    }, () => this.getRequestTickets());
                    this.props.addToast('Request ticket added successfully.', 5, 'success')
                } else {
                    this.props.addToast('Unable to add request ticket.', 5, 'danger')
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    setEditBot = (id) => {
        this.props.log('BOTManagementContainer.js/setEditBOT (id)', id);
    }

    handleEditRequestTicket = () => {
        this.props.log('BOTManagementContainer.js/handleEditRequestTicket');
        fetch('/api/bot-management/' + this.state.botRequestTicketId, {
            method: 'PUT',
            body: JSON.stringify({
                date: this.state.editRequestTicket.date,
                employeeId: this.state.editRequestTicket.employeeId,
                teamId: this.state.editRequestTicket.teamId,
                clientId: this.state.editRequestTicket.clientId,
                requestId: this.state.editRequestTicket.requestId,
                requestOther: this.state.editRequestTicket.requestOther,
                connectivityId: this.state.editRequestTicket.connectivityId,
                connectivityOther: this.state.editRequestTicket.connectivityOther,
                priorityId: this.state.editRequestTicket.priorityId,
                timeSavedEstimate: this.state.editRequestTicket.timeSavedEstimate,
                clientDirected: this.state.editRequestTicket.clientDirected,
                notes: this.state.editRequestTicket.notes,
                statusId: this.state.editRequestTicket.statusId,
                assignedEmployeeId: this.state.editRequestTicket.assignedEmployeeId,
                priorityRankId: this.state.editRequestTicket.priorityRankId,
                timeEstimate: this.state.editRequestTicket.timeEstimate,
                completed: this.state.editRequestTicket.completed,
                updateNotes: this.state.editRequestTicket.updateNotes,
                projectType: this.state.editRequestTicket.projectType,
                technologyStatus: this.state.editRequestTicket.technologyStatus,
                version: this.state.editRequestTicket.version,
                applicationName: this.state.editRequestTicket.applicationName,
                applicationType: this.state.editRequestTicket.applicationType,
                technologyNotes: this.state.editRequestTicket.technologyNotes,
                clientsUsing: JSON.stringify(this.state.editRequestTicket.clientsUsing)
            }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.setState({
                        botRequestTicketId: 0,
                        editRequestTicket: { ...this.blankRequestTicket },
                    }, () => this.getRequestTickets());
                    this.props.addToast('Request ticket updated successfully.', 5, 'success')
                } else {
                    this.props.addToast('Unable to update request ticket.', 5, 'danger')
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    reorder = (data, save, toIndex) => {
        this.props.log('BOTManagementContainer.js/reorder()', toIndex);
        let dbBotRequestTickets = [];
        let counter = 0;

        data = data.map((bot, loopIndex) => {
            let newOrder = bot.order != null ? bot.order : null;
            if (toIndex != null && bot.priorityRankId === data[toIndex].priorityRankId && (bot.order != null || loopIndex <= toIndex)) {
                dbBotRequestTickets.push({ id: bot.id })
                newOrder = (counter + 1) * 10;
                counter++;
            }
            return { ...bot, order: newOrder }
        })
        let mergedArray = [...this.state.botRequestTickets].map((item1) => {
            const matchingItem = data.find((item2) => item2.id === item1.id);

            if (matchingItem) {
                return { ...item1, ...matchingItem };
            }

            return item1;
        });
        if (this.state.selectedSortAscending) {
            mergedArray = mergedArray.sort((a, b) => (b.order != null ? b.order : 0) - (a.order != null ? a.order : 0));
            mergedArray = mergedArray.sort((a, b) => (a.priorityRankId != null ? a.priorityRankId : null) - (b.priorityRankId != null ? b.priorityRankId : null));
        } else {
            mergedArray = mergedArray.sort((a, b) => (a.order != null ? a.order : 999999) - (b.order != null ? b.order : 999999));
            mergedArray = mergedArray.sort((a, b) => (b.priorityRankId != null ? b.priorityRankId : null) - (a.priorityRankId != null ? a.priorityRankId : null));
        }

        this.setState({ botRequestTickets: mergedArray }, () => {
            if (save) {
                fetch('/api/bot-management-order/', {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + this.props.clientToken
                    },
                    body: JSON.stringify(
                        { botRequestTickets: data.filter(item => item.order != null).map(item => { return { id: item.id, order: item.order } }) }
                    )
                })
                    .catch(() => {
                        this.props.addToast('An error has occurred.', 5, 'danger');
                    })
            }
        });
    }

    render() {
        this.props.info('BOTManagementContainer.js/render');
        const botRequestTicketsCustomer = [...this.state.botRequestTickets].filter(bot => parseInt(bot.projectType) === 1 && parseInt(bot.technologyStatus) !== 2 /* && bot.statusId !== 5 */);
        const botRequestTicketsInternal = [...this.state.botRequestTickets].filter(bot => parseInt(bot.projectType) === 2 && parseInt(bot.technologyStatus) !== 2 /* && bot.technologyStatus !== 5 */);
        const botRequestTicketsOtherAssigned = [...this.state.botRequestTickets].filter(bot => parseInt(bot.projectType) !== 1 && parseInt(bot.projectType) !== 2 && parseInt(bot.statusId) >= 2 && parseInt(bot.statusId) <= 4 && parseInt(bot.technologyStatus) !== 2 /*&& bot.assignedEmployeeId != null */);
        // const botRequestTicketsOtherUnassigned = [...this.state.botRequestTickets].filter(bot => parseInt(bot.projectType) !== 1 && parseInt(bot.projectType) !== 2 && parseInt(bot.statusId) < 2  && parseInt(bot.technologyStatus) !== 2 /*&& bot.assignedEmployeeId == null*/);
        const botRequestTicketsRejected = [...this.state.botRequestTickets].filter(bot => parseInt(bot.statusId) === 5 && parseInt(bot.technologyStatus) !== 2);
        const botRequestTicketsInactive = [...this.state.botRequestTickets].filter(bot => parseInt(bot.technologyStatus) === 2);
        const botRequestTicketsCompleted = [...this.state.botRequestTickets].filter(bot => parseInt(bot.statusId) === 4 && parseInt(bot.technologyStatus) !== 2);
        const botAll = [...new Set(botRequestTicketsCustomer.map(i => i.id)
            .concat(botRequestTicketsInternal.map(i => i.id))
            .concat(botRequestTicketsOtherAssigned.map(i => i.id))
            // .concat(botRequestTicketsOtherUnassigned.map(i => i.id))
            .concat(botRequestTicketsRejected.map(i => i.id))
            .concat(botRequestTicketsInactive.map(i => i.id))
            .concat(botRequestTicketsCompleted.map(i => i.id))
        )].sort((a,b) => a - b);
        const excludeAll = [...this.state.botRequestTickets].filter(bot => botAll.findIndex(i => i === bot.id) === -1);
        return (
            // (this.state.isLoaded) ?
            <>
                {this.state.botRequestTickets.length > 0 && <>
                    {/* <CollapseCard title="BackOffice Management" open={this.props.singleEmployee ? false : true}> */}
                    <BOTManagementLists
                        {...this.props}
                        {...this.state}
                        botRequestTicketsCustomer={botRequestTicketsCustomer}
                        botRequestTicketsInternal={botRequestTicketsInternal}
                        botRequestTicketsRejected={botRequestTicketsRejected}
                        onEdit={this.onEditRequestTicket}
                        columns={this.columns}
                    />
                    {/* </CollapseCard>*/}
                    <div className='mt-5'></div>
                    <CollapseCard title={`Customers (${botRequestTicketsCustomer.length})`} open={false} forceOpen={(botRequestTicketsCustomer.findIndex(bot => bot.id === this.state.botRequestTicketId) > -1)}>
                        <BOTManagementForm
                            {...this.props}
                            {...this.state}
                            botRequestTickets={botRequestTicketsCustomer}
                            onChange={this.onChangeRequestTicket}
                            onEdit={this.onEditRequestTicket}
                            onDelete={this.onDeleteRequestTicket}
                            handleAdd={this.handleAddRequestTicket}
                            handleEdit={this.handleEditRequestTicket}
                            handleCancel={this.handleCancelRequestTicket}
                            handleSort={this.handleSort}
                            reorder={this.reorder}
                            columns={this.columns}
                            addNew={false}
                        />
                    </CollapseCard>
                    <CollapseCard title={`Internal (${botRequestTicketsInternal.length})`} open={false} forceOpen={(botRequestTicketsInternal.findIndex(bot => bot.id === this.state.botRequestTicketId) > -1)}>
                        <BOTManagementForm
                            {...this.props}
                            {...this.state}
                            botRequestTickets={botRequestTicketsInternal}
                            onChange={this.onChangeRequestTicket}
                            onEdit={this.onEditRequestTicket}
                            onDelete={this.onDeleteRequestTicket}
                            handleAdd={this.handleAddRequestTicket}
                            handleEdit={this.handleEditRequestTicket}
                            handleCancel={this.handleCancelRequestTicket}
                            handleSort={this.handleSort}
                            reorder={this.reorder}
                            columns={this.columns}
                            addNew={false}
                        />
                    </CollapseCard>
                    <CollapseCard title={`Other (Assigned) (${botRequestTicketsOtherAssigned.length})`} open={false} forceOpen={(botRequestTicketsOtherAssigned.findIndex(bot => bot.id === this.state.botRequestTicketId) > -1)}>
                        <BOTManagementForm
                            {...this.props}
                            {...this.state}
                            botRequestTickets={botRequestTicketsOtherAssigned}
                            onChange={this.onChangeRequestTicket}
                            onEdit={this.onEditRequestTicket}
                            onDelete={this.onDeleteRequestTicket}
                            handleAdd={this.handleAddRequestTicket}
                            handleEdit={this.handleEditRequestTicket}
                            handleCancel={this.handleCancelRequestTicket}
                            handleSort={this.handleSort}
                            reorder={this.reorder}
                            columns={this.columns}
                        />
                    </CollapseCard>
                    {/* <CollapseCard title={`Other (Unassigned) (${botRequestTicketsOtherUnassigned.length})`} open={false} forceOpen={(botRequestTicketsOtherUnassigned.findIndex(bot => bot.id === this.state.botRequestTicketId) > -1)}>
                        <BOTManagementForm
                            {...this.props}
                            {...this.state}
                            botRequestTickets={botRequestTicketsOtherUnassigned}
                            onChange={this.onChangeRequestTicket}
                            onEdit={this.onEditRequestTicket}
                            onDelete={this.onDeleteRequestTicket}
                            handleAdd={this.handleAddRequestTicket}
                            handleEdit={this.handleEditRequestTicket}
                            handleCancel={this.handleCancelRequestTicket}
                            handleSort={this.handleSort}
                            reorder={this.reorder}
                            columns={this.columns}
                        />
                    </CollapseCard> */}
                    {excludeAll.length > 0 && <CollapseCard title={`Other (Unassigned) (${excludeAll.length})`} open={false}>
                        <BOTManagementForm
                            {...this.props}
                            {...this.state}
                            botRequestTickets={excludeAll}
                            onChange={this.onChangeRequestTicket}
                            onEdit={this.onEditRequestTicket}
                            onDelete={this.onDeleteRequestTicket}
                            handleAdd={this.handleAddRequestTicket}
                            handleEdit={this.handleEditRequestTicket}
                            handleCancel={this.handleCancelRequestTicket}
                            handleSort={this.handleSort}
                            reorder={this.reorder}
                            columns={this.columns}
                        />
                    </CollapseCard>}
                    <CollapseCard title={`Rejected (${botRequestTicketsRejected.length})`} open={false} forceOpen={(botRequestTicketsRejected.findIndex(bot => bot.id === this.state.botRequestTicketId) > -1)}>
                        <BOTManagementForm
                            {...this.props}
                            {...this.state}
                            botRequestTickets={botRequestTicketsRejected}
                            onChange={this.onChangeRequestTicket}
                            onEdit={this.onEditRequestTicket}
                            onDelete={this.onDeleteRequestTicket}
                            handleAdd={this.handleAddRequestTicket}
                            handleEdit={this.handleEditRequestTicket}
                            handleCancel={this.handleCancelRequestTicket}
                            handleSort={this.handleSort}
                            reorder={this.reorder}
                            columns={this.columns}
                            addNew={false}
                        />
                    </CollapseCard>
                    <CollapseCard title={`Inactive (${botRequestTicketsInactive.length})`} open={false}>
                        <BOTManagementForm
                            {...this.props}
                            {...this.state}
                            botRequestTickets={botRequestTicketsInactive}
                            onChange={this.onChangeRequestTicket}
                            onEdit={this.onEditRequestTicket}
                            onDelete={this.onDeleteRequestTicket}
                            handleAdd={this.handleAddRequestTicket}
                            handleEdit={this.handleEditRequestTicket}
                            handleCancel={this.handleCancelRequestTicket}
                            handleSort={this.handleSort}
                            reorder={this.reorder}
                            columns={this.columns}
                        />
                    </CollapseCard>
                    {/* <CollapseCard title={`Completed (${botRequestTicketsCompleted.length})`} open={false}>
                        <BOTManagementForm
                            {...this.props}
                            {...this.state}
                            botRequestTickets={botRequestTicketsCompleted}
                            onChange={this.onChangeRequestTicket}
                            onEdit={this.onEditRequestTicket}
                            onDelete={this.onDeleteRequestTicket}
                            handleAdd={this.handleAddRequestTicket}
                            handleEdit={this.handleEditRequestTicket}
                            handleCancel={this.handleCancelRequestTicket}
                            handleSort={this.handleSort}
                            reorder={this.reorder}
                            columns={this.columns}
                        />
                    </CollapseCard> */}
                </>
                }
            </>
            // :
            // <h3>Loading...</h3>
        );

    }
}

export default BOTManagementContainer;
